var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',{staticClass:"main-bg"},[_c('el-container',{staticClass:"container user-container "},[_c('el-main',{staticClass:"right-column center-bg",staticStyle:{"overflow":"hidden"}},[_c('router-view',{on:{"LoginBox":_vm.LoginBox}})],1)],1)],1),_vm._v(" "),_c('LoginBox',{ref:"LoginBox"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aca3db5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/User.vue
// module id = null
// module chunks = 